/**
 * Texte affiché sous les paramètres entreprise (journal applicatif).
 * @param {{ modifiedBy?: string, modifiedAt?: string | Date }} lastModified
 */
export function formatCompanySettingLastModified(lastModified) {
  if (!lastModified?.modifiedAt || !lastModified?.modifiedBy) return null;
  const d = new Date(lastModified.modifiedAt);
  if (Number.isNaN(d.getTime())) return null;
  const dateStr = d.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const timeStr = d.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `Modifié par ${lastModified.modifiedBy} le ${dateStr} à ${timeStr}`;
}
